const INLINE_RATING_SELECTOR = '[data-bv-show="inline_rating"]'
const HIDDEN_CLASS = 'bv-inline-rating--hidden'

const TEXT_PATTERNS = [
  /no reviews/i,
  /be the first/i,
  /\b0\s*reviews?\b/i,
  /\b0\s*ratings?\b/i,
]

const CLASS_PATTERNS = [
  /\bbv-no-review(s)?\b/i,
  /\bbv-no-rating(s)?\b/i,
  /\bbv-empty\b/i,
  /\bbv-zero\b/i,
]

function ariaIndicatesZeroRating(container) {
  const labeled = container.querySelectorAll('[aria-label]')
  for (const el of labeled) {
    const label = (el.getAttribute('aria-label') || '').toLowerCase()
    if (!label.includes('out of')) continue
    const match = label.match(/(\d+(?:\.\d+)?)/)
    if (!match) continue
    const value = Number(match[1])
    if (!Number.isNaN(value) && value === 0) return true
  }
  return false
}

function classIndicatesNoReviews(container) {
  const elements = container.querySelectorAll('[class]')
  for (const el of elements) {
    const className = el.className || ''
    if (!className) continue
    for (const pattern of CLASS_PATTERNS) {
      if (pattern.test(className)) return true
    }
  }
  return false
}

function textIndicatesNoReviews(container) {
  const text = (container.textContent || '').trim().toLowerCase()
  if (!text) return false
  return TEXT_PATTERNS.some((pattern) => pattern.test(text))
}

function shouldHideInlineRating(container) {
  if (!container || container.children.length === 0) return false
  if (classIndicatesNoReviews(container)) return true
  if (ariaIndicatesZeroRating(container)) return true
  if (textIndicatesNoReviews(container)) return true
  return false
}

function applyVisibility(container) {
  const hide = shouldHideInlineRating(container)
  container.classList.toggle(HIDDEN_CLASS, hide)
}

function observeInlineRating(container) {
  if (container.__bvObserverAttached) return
  container.__bvObserverAttached = true

  const observer = new MutationObserver(() => {
    applyVisibility(container)
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
  })

  applyVisibility(container)
}

function initInlineRatingHider(root = document) {
  root.querySelectorAll(INLINE_RATING_SELECTOR).forEach(observeInlineRating)
}

initInlineRatingHider()

const bodyObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue
      if (node.matches?.(INLINE_RATING_SELECTOR)) {
        observeInlineRating(node)
      }
      if (node.querySelectorAll) {
        node.querySelectorAll(INLINE_RATING_SELECTOR).forEach(observeInlineRating)
      }
    }
  }
})

bodyObserver.observe(document.body, { childList: true, subtree: true })
